import React from 'react';
import { Typography } from "../common/Typography";
import UsersNameDisplay from "../users/UsersNameDisplay";
import LoadMore from "../common/LoadMore";
import { useQueryWithLoadMore } from "@/components/hooks/useQueryWithLoadMore";
import { gql } from "@/lib/generated/gql-codegen";
import { defineStyles } from '../hooks/defineStyles';
import { useStyles } from '../hooks/useStyles';

const MembersOfGroupFragmentMultiQuery = gql(`
  query multiSubscriptionLocalGroupSubscribersQuery($selector: SubscriptionSelector, $limit: Int, $enableTotal: Boolean) {
    subscriptions(selector: $selector, limit: $limit, enableTotal: $enableTotal) {
      results {
        ...MembersOfGroupFragment
      }
      totalCount
    }
  }
`);

const styles = defineStyles("LocalGroupSubscribers", (theme: ThemeType) => ({
  title: {
    marginTop: 24,
  },
  subscriberList: {
  },
  subscriber: {
  },
}))

const LocalGroupSubscribers = ({groupId}: {
  groupId: string,
}) => {
  const classes = useStyles(styles);
  const { data, loading, loadMoreProps } = useQueryWithLoadMore(MembersOfGroupFragmentMultiQuery, {
    variables: {
      selector: { membersOfGroup: { documentId: groupId } },
      limit: 20,
      enableTotal: true,
    },
    itemsPerPage: 100,
  });

  const results = data?.subscriptions?.results;

  const totalCount = data?.subscriptions?.totalCount;

  return <div>
    <Typography variant="headline" className={classes.title}>
      {"Subscribers"}{!loading && ` (${totalCount})`}
    </Typography>
    
    <Typography variant="body2" className={classes.subscriber}>
      <ol className={classes.subscriberList}>
        {results?.map(result => (result.user) && <li key={result.user._id}>
            <UsersNameDisplay user={result.user}/>
        </li>)}
      </ol>
    </Typography>
    
    <LoadMore {...loadMoreProps} />
  </div>
}

export default LocalGroupSubscribers;
